import { BinaryDecoder, BinaryEncoder } from 'fluent-binary-converter';
/**
 * @public
 */

var SplitFile =
/** @class */
function () {
  function SplitFile() {
    this.textEncoder = new TextEncoder();
    this.textDecoder = new TextDecoder();
  }

  SplitFile.prototype.decodeBlock = function (block) {
    var binaryDecoder = new BinaryDecoder(block.buffer, block.byteOffset);
    var totalBytesCount = binaryDecoder.getUint32();
    var fileNameBinaryLength = binaryDecoder.getUint32();
    var fileName = this.decode(binaryDecoder.getBinary(fileNameBinaryLength));
    var totalBlockCount = binaryDecoder.getUint32();
    var currentBlockIndex = binaryDecoder.getUint32();
    var binary = binaryDecoder.getBinary();
    return {
      totalBytesCount: totalBytesCount,
      fileName: fileName,
      totalBlockCount: totalBlockCount,
      currentBlockIndex: currentBlockIndex,
      binary: binary
    };
  };

  SplitFile.prototype.split = function (uint8Array, fileName, size) {
    if (size === void 0) {
      size = 10000;
    }

    var blocks = [];

    if (uint8Array.length === 0) {
      return blocks;
    }

    var totalBlockCount = Math.floor((uint8Array.length - 1) / size) + 1;
    var totalBlockCountBinary = BinaryEncoder.fromUint32(true, totalBlockCount);
    var totalBytesCountBinary = BinaryEncoder.fromUint32(true, uint8Array.length);
    var fileNameBinary = this.encode(fileName);
    var fileNameBinaryLengthBinary = BinaryEncoder.fromUint32(true, fileNameBinary.length);

    for (var i = 0; i < totalBlockCount; i++) {
      var binary = uint8Array.subarray(i * size, i * size + size);
      var currentBlockIndexBinary = BinaryEncoder.fromUint32(true, i);
      var block = BinaryEncoder.concat(totalBytesCountBinary, fileNameBinaryLengthBinary, fileNameBinary, totalBlockCountBinary, currentBlockIndexBinary, binary);
      blocks.push(block);
    }

    return blocks;
  };

  SplitFile.prototype.encode = function (text) {
    return this.textEncoder.encode(text);
  };

  SplitFile.prototype.decode = function (uint8Array) {
    return this.textDecoder.decode(uint8Array);
  };

  return SplitFile;
}();

export default SplitFile;